import { render, staticRenderFns } from "./WordLeagueScheduleDownload.vue?vue&type=template&id=2a8798b1"
import script from "./WordLeagueScheduleDownload.vue?vue&type=script&lang=js"
export * from "./WordLeagueScheduleDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports